import React from 'react';
import { Dropdown, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getNumberedOptions } from './util';

// const numberedOptions = getNumberedOptions(10, 40, 10);
const numberedOptions = [
    {
        key: 10,
        value: 10,
        text: '10'
    }, {
        key: 25,
        value: 25,
        text: '25'
    }, {
        key: 50,
        value: 50,
        text: '50'
    },
    {
        key: 0,
        value: 0,
        text: 'Sve'
    }
];


/**
 * [ResultsPerPageDropdown description]
 * @param {[number]} resultsPerPage         [description]
 * @param {[func]} onResultsPerPageChange [description]
 */
const ResultsPerPageDropdown = ({
    resultsPerPage, onResultsPerPageChange
}) => (
    <Button.Group basic floated="right" size="medium" style={{ marginBottom: '0', bottom: '0' }}>
        {/* <Button disabled>Broj redova</Button> */}
        <Dropdown
            options={numberedOptions}
            value={resultsPerPage}
            onChange={onResultsPerPageChange}
            floating
            button
            compact
        />
    </Button.Group>
);

ResultsPerPageDropdown.propTypes = {
    resultsPerPage: PropTypes.number.isRequired,
    onResultsPerPageChange: PropTypes.func.isRequired,
};

export default ResultsPerPageDropdown;



// WEBPACK FOOTER //
// ./src/views/Assets/util/ResultsPerPageDropdown.js